module.exports = __webpack_public_path__ + "static/img/ARKI-BUTLER.8996a9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ARKI-BUTLER.jpg
// module id = D9KQ
// module chunks = 0